import { useMutation } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { recordGameEntry } from "../../../api/game-participant";
import type { GameStatus } from "../../../api/shared";

export function useRecordGameEntry(gameId: string, gameStatus?: GameStatus) {
  const firedForGameRef = useRef<string | null>(null);
  const { mutate } = useMutation({
    mutationFn: (id: string) => recordGameEntry(id),
    retry: false,
  });

  useEffect(() => {
    if (firedForGameRef.current === gameId) return;
    if (gameStatus !== "about_to_start" && gameStatus !== "in_progress") return;

    firedForGameRef.current = gameId;
    // Fire-and-forget — errors are swallowed by not consuming mutation state
    mutate(gameId);
  }, [gameId, gameStatus, mutate]);
}
